import React from 'react';
import { Tracker, TrackImpression } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { UFBNoticeClickEvent, UFBNoticeImpressionEvent } from '../ufb-notice/events';
export const Link = ({
  href,
  text,
  feature_flag,
  open_in_new_tab,
  data_purpose,
  style
}) => {
  if (feature_flag === 'footer.links.business') {
    return /*#__PURE__*/React.createElement(BusinessLink, {
      href: href,
      text: text,
      data_purpose: data_purpose
    });
  }
  let htmlProps = {};
  if (open_in_new_tab) {
    htmlProps = {
      target: '_blank',
      rel: 'noopener noreferrer'
    };
  }
  if (style) {
    htmlProps = {
      ...htmlProps,
      style
    };
  }
  if (data_purpose) {
    htmlProps = {
      ...htmlProps,
      'data-purpose': data_purpose
    };
  }
  return /*#__PURE__*/React.createElement("a", Object.assign({
    className: "link white-link ud-text-sm",
    href: href
  }, htmlProps), text);
};
const BusinessLink = ({
  href,
  text,
  data_purpose
}) => {
  const {
    locale
  } = useI18n();
  function trackImpression() {
    Tracker.publishEvent(new UFBNoticeImpressionEvent({
      locale,
      placement: 'footer',
      url: href
    }));
  }
  function handleClick() {
    Tracker.publishEvent(new UFBNoticeClickEvent({
      locale,
      placement: 'footer'
    }));
  }
  return (
    /*#__PURE__*/
    /* eslint-disable react/jsx-no-target-blank */
    /* this.props.href is always a business.udemy.com link.
     * We allow referrer for tracking purposes. */
    React.createElement(TrackImpression, {
      trackFunc: trackImpression
    }, /*#__PURE__*/React.createElement("a", {
      href: href,
      className: "link white-link ud-text-sm",
      target: "_blank",
      rel: "noopener",
      "data-purpose": data_purpose,
      onClick: handleClick
    }, text))
  );
};
//# sourceMappingURL=link.react-component.js.map